// Copyright 2026 Hardfin, Inc.
import { getZones } from '@/location/api/get-zones';
import { useSuspenseQuery } from '@tanstack/react-query';

export function useZones(
  locationKey: string,
  options?: { includeArchived?: boolean }
) {
  const { data } = useSuspenseQuery({
    queryKey: [
      'location',
      locationKey,
      'zones',
      { includeArchived: options?.includeArchived },
    ],
    queryFn: () => getZones(locationKey, options),
  });

  return { zones: data.zones };
}
